import React, { useEffect, useRef, useState } from 'react';
import './CircularProgress.scss';

const WIDTH = 300;
const HEIGHT = 300;

const CircularProgress = ({ targetPercentage = 70, targetValue = 120 }) => {
  const circleRef = useRef(null);
  const smallCircleRef = useRef(null);

  const radius = (WIDTH / 2) * 0.8; // Bán kính của vòng tròn
  const circumference = 2 * Math.PI * radius; // Chu vi của vòng tròn

  const [currentPercentage, setCurrentPercentage] = useState(0);
  const [currentValue, setCurrentValue] = useState(0);

  useEffect(() => {
    let percentageInterval, valueInterval;

    // Tạo interval để tăng dần phần trăm
    percentageInterval = setInterval(() => {
      setCurrentPercentage((prev) => {
        if (prev < targetPercentage) {
          return prev + 1; // Tăng 1% mỗi lần
        } else {
          clearInterval(percentageInterval);
          return targetPercentage;
        }
      });
    }, 20); // Điều chỉnh tốc độ cập nhật percentage (ms)

    // Tạo interval để tăng dần giá trị
    valueInterval = setInterval(() => {
      setCurrentValue((prev) => {
        if (prev < targetValue) {
          return prev + 1; // Tăng 1 đơn vị mỗi lần
        } else {
          clearInterval(valueInterval);
          return targetValue;
        }
      });
    }, 10); // Điều chỉnh tốc độ cập nhật giá trị

    return () => {
      clearInterval(percentageInterval);
      clearInterval(valueInterval);
    };
  }, [targetPercentage, targetValue]);

  useEffect(() => {
    if (smallCircleRef.current) {
      // Tính strokeDashoffset
      const offset = circumference * (1 - currentPercentage / 100);
      circleRef.current.style.strokeDashoffset = offset;

      // Tính góc hiện tại và vị trí của vòng tròn nhỏ
      const angle = (currentPercentage / 100) * 2 * Math.PI; // Góc từ 0 đến 2π
      const centerX = WIDTH / 2; // Tọa độ X trung tâm của SVG
      const centerY = HEIGHT / 2; // Tọa độ Y trung tâm của SVG

      // Tính tọa độ vòng tròn nhỏ màu trắng
      const x = centerX - radius * Math.cos(angle - Math.PI);
      const y = centerY - radius * Math.sin(angle - Math.PI);

      // Cập nhật vị trí vòng tròn nhỏ
      smallCircleRef.current.setAttribute('cx', x);
      smallCircleRef.current.setAttribute('cy', y);
    }
  }, [currentPercentage, circumference, radius]);

  return (
    <div className="circular-progress-container">
      <h4 className="title">Công suất max/tuần</h4>
      <div
        className="circular-progress"
        style={{ width: WIDTH, height: HEIGHT }}
      >
        <svg width={WIDTH} height={HEIGHT} className="progress-ring">
          {/* Vòng tròn nền */}
          <circle
            className="progress-ring__circle--bg"
            cx={WIDTH / 2}
            cy={HEIGHT / 2}
            r={radius}
            fill="none"
            stroke="#2c2c2c"
            strokeWidth={(WIDTH / 2) * 0.3}
          />
          {/* Vòng tròn tiến trình */}
          <circle
            ref={circleRef}
            className="progress-ring__circle"
            cx={WIDTH / 2}
            cy={HEIGHT / 2}
            r={radius}
            fill="none"
            stroke="url(#gradient)"
            strokeWidth={(WIDTH / 2) * 0.3 - 2}
            strokeDasharray={circumference}
            strokeDashoffset={circumference}
            strokeLinecap="round"
          />
          {/* Gradient màu xanh */}
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#9dbbff" />
              <stop offset="100%" stopColor="#667aff" />
            </linearGradient>
          </defs>
          {/* Vòng tròn nhỏ màu trắng */}
          <circle
            ref={smallCircleRef}
            className="progress-ring__small-circle"
            cx={WIDTH - 15}
            cy={HEIGHT / 2}
            r="20"
            fill="#ffffff"
          />
        </svg>
        {/* Giá trị trung tâm */}
        <div className="progress-value">
          <span>{currentValue}</span>
          <span className="unit">KW</span>
        </div>
        <div className="progress-icon">
          <span className="icon">⚡</span>
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;
